import {
    EDIT_DELETE_DELETE_DELIVERY_CHALLAN_PROGRESS, EDIT_DELETE_DELETE_DELIVERY_CHALLAN_SUCCESS, EDIT_DELETE_DELETE_DELIVERY_CHALLAN_FAILURE,

    RESET_MESSAGE,
    GET_DELIVERY_CHALLAN_LIST_SUCCESS,
    GET_DELIVERY_CHALLAN_LIST_FAILURE,
    GET_DELIVERY_CHALLAN_LIST_PROGRESS,
    ADD_DELIVERY_CHALLAN_PROGRESS,
    ADD_DELIVERY_CHALLAN_SUCCESS,
    ADD_DELIVERY_CHALLAN_FAILURE,
    EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS,
    EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS,
    EDIT_DELETE_DELIVERY_CHALLAN_FAILURE,

} from '../../types/actionTypes';

const initialState = {
    delivery_challan: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const delivery_challan_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_DELIVERY_CHALLAN_LIST_SUCCESS:
            return { ...state, delivery_challan: action.delivery_challan, loading: false };
        case GET_DELIVERY_CHALLAN_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_DELIVERY_CHALLAN_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_DELIVERY_CHALLAN_PROGRESS:
            return { ...state, loading: true };
        case ADD_DELIVERY_CHALLAN_SUCCESS:
            return { ...state, delivery_challan: [...state.delivery_challan, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_DELIVERY_CHALLAN_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS:
            return {
                ...state,
                delivery_challan: state.delivery_challan.map((delivery_challan) =>
                    delivery_challan.id === action.payload.id ? action.payload : delivery_challan
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_DELIVERY_CHALLAN_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default delivery_challan_reducer;